import { ButtonHTMLAttributes, PropsWithChildren } from 'react'

export default function PrimaryButton({
  children,
  className,
  ...props
}: PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>): JSX.Element {
  return (
    <button
      className={`bvi-img-no-styles font-bold py-[14px] px-7 rounded-2xl bg-gradient-to-r from-green-dark-landing to-green-light-landing hover:bg-gradient-to-l text-white ${
        className ?? ''
      }`}
      style={{
        boxShadow: ' 0px 5px 20px rgba(0, 0, 0, 0.05)'
      }}
      {...props}
    >
      {children}
    </button>
  )
}
